// import React, { useEffect, useContext, useReducer } from "react";
// import {
//   BrowserRouter as Router,
//   Route,
//   Switch,
//   useHistory,
//   useLocation,
// } from "react-router-dom";
// import NavBar from "./components/Navbar";
// import Signin from "./components/screens/SignIn";
// import Signup from "./components/screens/Signup";
// import CreatePost from "./components/screens/CreatePost";
// import VotePage from "./components/screens/VotePage";
// import { UserContext, userReducer, initialState } from "./contexts/UserContext";
// import ProtectedRoute from "./components/ProtectedRoute"; // Import the ProtectedRoute component

// const Routing = () => {
//   const history = useHistory();
//   const location = useLocation();
//   const { state, dispatch } = useContext(UserContext);

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (user) {
//       dispatch({ type: "USER", payload: user });
//     } else {
//       if (
//         !history.location.pathname.startsWith("/signin") &&
//         !history.location.pathname.startsWith("/signup") &&
//         !history.location.pathname.startsWith("/")
//       ) {
//         history.push("/signin");
//       }
//     }
//   }, [dispatch, history]);

//   return (
//     <>
//       {location.pathname !== "/" && <NavBar />}
//       <Switch>
//         <Route exact path="/">
//           <VotePage />
//         </Route>
//         <Route path="/signin">
//           <Signin />
//         </Route>
//         <Route path="/signup">
//           <Signup />
//         </Route>
//         <ProtectedRoute path="/createpost" component={CreatePost} adminOnly />
//       </Switch>
//     </>
//   );
// };

// function App() {
//   const [state, dispatch] = useReducer(userReducer, initialState);

//   return (
//     <UserContext.Provider value={{ state, dispatch }}>
//       <Router>
//         <Routing />
//       </Router>
//     </UserContext.Provider>
//   );
// }

// export default App;

import React, { useEffect, useContext, useReducer } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import NavBar from "./components/Navbar";
import Signin from "./components/screens/SignIn";
import Signup from "./components/screens/Signup";
import CreatePost from "./components/screens/CreatePost";
import VotePage from "./components/screens/VotePage";
import { UserContext, userReducer, initialState } from "./contexts/UserContext";
import ProtectedRoute from "./components/ProtectedRoute"; // Import the ProtectedRoute component

const Routing = () => {
  const history = useHistory();
  const location = useLocation();
  const { state, dispatch } = useContext(UserContext);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      dispatch({ type: "USER", payload: user });
    } else {
      if (
        !history.location.pathname.startsWith("/signin") &&
        !history.location.pathname.startsWith("/signup") &&
        !history.location.pathname.startsWith("/")
      ) {
        history.push("/signin");
      }
    }
  }, [dispatch, history]);

  return (
    <>
      {location.pathname !== "/" && <NavBar />}
      <Switch>
        <Route exact path="/">
          <VotePage />
        </Route>
        <Route path="/signin">
          <Signin />
        </Route>
        <Route path="/signup">
          <Signup />
        </Route>
        <ProtectedRoute path="/createpost" component={CreatePost} adminOnly />
      </Switch>
    </>
  );
};

function App() {
  const [state, dispatch] = useReducer(userReducer, initialState);

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      <Router>
        <Routing />
      </Router>
    </UserContext.Provider>
  );
}

export default App;
